import { toast } from 'react-toastify'
import { v4 as uuid } from 'uuid'
import { makeAutoObservable } from 'mobx'

import CustomToast from './CustomToast'

class ErrorHandler {
    persistedErrors = new Map()

    constructor() {
        makeAutoObservable(this)
    }

    createToast = ({
        level, title, body, persist,
    }) => {
        if (persist) {
            this.persistError({ level, title, body })
            return
        }

        switch (level) {
            case 'warning':
                this.handleWarning({ title, body })
                break
            case 'error':
                this.handleError({ title, body })
                break
            default:
                toast(CustomToast, {
                    title,
                    body,
                })
        }
    }

    handleWarning = ({ title, body }) => {
        toast.warning(CustomToast, {
            title,
            body,
        })
    }

    handleError = ({ title, body }) => {
        toast.error(CustomToast, {
            title: title ?? 'Something went wrong',
            body,
        })
    }

    persistError = ({ title, body }) => {
        const id = uuid()
        this.persistedErrors.set(id, {
            title: title ?? 'Something went wrong',
            body,
            onClose: () => this.clearPersistedError(id),
        })

        toast.error(CustomToast, {
            autoClose: false,
            title: title ?? 'Something went wrong',
            body,
            onClose: () => this.clearPersistedError(id),
        })
    }

    registerPersistedError = (id, { title, body }) => {
        this.persistedErrors.set(id, {
            title: title ?? 'Something went wrong',
            body,
            onClose: () => this.clearPersistedError(id),
        })
    }

    clearPersistedError = (id) => {
        if (!this.persistedErrors.has(id)) return

        this.persistedErrors.delete(id)
    }
}

export default ErrorHandler
